module.exports = __webpack_public_path__ + "media/images/product/p_f-05f92c67f837688f12b2c240f8e6d729.png";